define( function() {
	return window.location;
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/ajax/var/location.js
// module id = 1777
// module chunks = 0